// GWINS Gear API Service
// Handles all API calls to the backend

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Helper function for API requests
async function fetchAPI(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(url, { ...defaultOptions, ...options });
  
  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }
  
  return response.json();
}

// Teams API
export const teamsAPI = {
  getAll: async () => {
    const data = await fetchAPI('/api/teams');
    return data.teams || [];
  },
  
  getById: async (teamId) => {
    const data = await fetchAPI(`/api/teams/${teamId}`);
    return data;
  },
  
  getFeatured: async () => {
    const teams = await teamsAPI.getAll();
    return teams.find(team => team.featured) || null;
  },
};

// News API
export const newsAPI = {
  getAll: async () => {
    const data = await fetchAPI('/api/news');
    // Handle both array response and object with news property
    return Array.isArray(data) ? data : (data.news || []);
  },
  
  getActive: async () => {
    const news = await newsAPI.getAll();
    return news.filter(item => item.active !== false);
  },
};

// Media API
export const mediaAPI = {
  getAll: async () => {
    const data = await fetchAPI('/api/media');
    return data.media || [];
  },
  
  getByTeam: async (teamId) => {
    const media = await mediaAPI.getAll();
    return media.filter(item => item.team_id === teamId);
  },
  
  getSponsored: async () => {
    const media = await mediaAPI.getAll();
    return media.filter(item => item.is_sponsored);
  },
};

// Health check
export const healthAPI = {
  check: async () => {
    return fetchAPI('/api/health');
  },
};

// Shopify API
export const shopifyAPI = {
  // Get store status
  getStatus: async () => {
    return fetchAPI('/api/shopify/status');
  },

  // Get all products
  getProducts: async (first = 20, after = null) => {
    const params = new URLSearchParams({ first: first.toString() });
    if (after) params.append('after', after);
    const data = await fetchAPI(`/api/shopify/products?${params}`);
    return data;
  },

  // Get single product by handle
  getProduct: async (handle) => {
    return fetchAPI(`/api/shopify/products/${handle}`);
  },

  // Get collections
  getCollections: async (first = 10) => {
    const data = await fetchAPI(`/api/shopify/collections?first=${first}`);
    return data.collections || [];
  },

  // Create cart
  createCart: async (items) => {
    return fetchAPI('/api/shopify/cart/create', {
      method: 'POST',
      body: JSON.stringify({ items }),
    });
  },

  // Get cart
  getCart: async (cartId) => {
    return fetchAPI(`/api/shopify/cart/${encodeURIComponent(cartId)}`);
  },

  // Add to cart
  addToCart: async (cartId, variantId, quantity = 1) => {
    return fetchAPI(`/api/shopify/cart/${encodeURIComponent(cartId)}/add`, {
      method: 'POST',
      body: JSON.stringify({ variant_id: variantId, quantity }),
    });
  },
};

export default {
  teams: teamsAPI,
  news: newsAPI,
  media: mediaAPI,
  health: healthAPI,
  shopify: shopifyAPI,
};
